import { render, staticRenderFns } from "./RuleListItens.vue?vue&type=template&id=3d45de7a&scoped=true"
import script from "./RuleListItens.vue?vue&type=script&lang=ts"
export * from "./RuleListItens.vue?vue&type=script&lang=ts"
import style0 from "./RuleListItens.vue?vue&type=style&index=0&id=3d45de7a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d45de7a",
  null
  
)

export default component.exports